import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Stepper from "@material-ui/core/Stepper";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import * as React from "react";
import { IntlShape, useIntl } from "react-intl";
import { GetTranslation } from "../../translations/GetTranslation";
import {
  CertificationDataWizardProvider,
  useSignUpContext,
} from "./CertificationDataWizardContext/CertificationDataWizardContext";
import EmailConfirmationSent from "./components/EmailConfirmationSent";
import PersonalDataStep from "./components/Step1_PersonalData/PersonalDataStep";
import ModuleSelectionStep from "./components/Step2_ModuleSelection/ModuleSelectionStep";
import ExamLocationAndDateStep from "./components/Step3_ExamDetails/ExamLocationAndDateStep";
import ModulesDetailsStep from "./components/Step4_ModulesDetails/ModulesDetailsStep";
import StartCertificationSteps from "./CertificationDataWizardContext/StartCertificationSteps";
import PaymentAndCompletionStep from "./components/Step5_PaymentAndCompletion/PaymentAndCompletionStep";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
    },
    stepper: {
      padding: "0 0 40px 0",
      marginBottom: 20,
    },
    buttonContainer: {
      marginTop: 40,
      display: "flex",
      justifyContent: "center",
    },
    button: {
      marginRight: theme.spacing(1),
    },
    instructions: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
  })
);

export const getSteps = (intl: IntlShape) => [
  GetTranslation(intl, "startCertification.personalDataStep.header"),
  GetTranslation(intl, "startCertification.courseModuleExamsStep.header"),
  GetTranslation(intl, "startCertification.locationDateStep.header"),
  GetTranslation(intl, "startCertification.modulesDetailsStep.header"),
  GetTranslation(intl, "startCertification.paymentAndCompletionStep.header"),
];

const getStepContent = (step: number) => {
  switch (step) {
    case StartCertificationSteps.PersonalDataStep:
      return <PersonalDataStep />;
    case StartCertificationSteps.ModuleSelectionStep:
      return <ModuleSelectionStep />;
    case StartCertificationSteps.ExamLocationAndDateStep:
      return <ExamLocationAndDateStep />;
    case StartCertificationSteps.ModulesDetailsStep:
      return <ModulesDetailsStep />;
    case StartCertificationSteps.PaymentAndCompletionStep:
      return <PaymentAndCompletionStep />;
    case StartCertificationSteps.EmailConfirmationSent:
      return <EmailConfirmationSent />;
    default:
      return "Unknown step";
  }
};

const StartCertificationWizard: React.FC = () => {
  const classes = useStyles();
  const intl = useIntl();
  const { activeStep } = useSignUpContext();
  const steps = getSteps(intl);

  return (
    <div className={classes.root}>
      <Stepper activeStep={activeStep} className={classes.stepper}>
        {steps.map((label) => {
          const stepProps: { completed?: boolean } = {};
          const labelProps: { optional?: React.ReactNode } = {};
          return (
            <Step key={label} {...stepProps}>
              <StepLabel {...labelProps}>{label}</StepLabel>
            </Step>
          );
        })}
      </Stepper>
      {getStepContent(activeStep)}
    </div>
  );
};

const StartCertificationWizardContainer: React.FC = () => (
  <CertificationDataWizardProvider>
    <StartCertificationWizard />
  </CertificationDataWizardProvider>
);

export default StartCertificationWizardContainer;
